import React, { useState, useEffect } from 'react';
import Button from '../common/Button';
import { useTranslation } from 'react-i18next';

interface MemoModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (value: string) => void;
    companyName: string | null;
    memoData?: string;
}

const MemoModal: React.FC<MemoModalProps> = ({ isOpen, onClose, onConfirm, companyName, memoData }) => {
    const { t } = useTranslation('header');
    const [updatedMemoData, setUpdatedMemoData] = useState<string>('')

    useEffect(() => {setUpdatedMemoData(memoData ?? '')}, [memoData])

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-40 items-center z-50">
            <div className="bg-white my-[15%] mx-auto w-4/5 max-w-lg p-5 border-[#888] rounded text-center text-black">
                <div className="modal-content">
                    <div className="flex flex-row justify-between items-center border-b">
                        <h3 className="modal-title">メモ</h3>
                        <button
                            className="close memo-close"
                            onClick={onClose}
                        >
                            &times;
                        </button>
                    </div>
                    <div className="text-left">
                        {companyName !== null && (
                            <p className="py-[15px]"><strong>法人名：</strong><span id="memoModalCompanyName">{companyName}</span></p>
                        )}
                        <textarea
                            id="memoTextarea"
                            placeholder="メモを入力してください..."
                            rows={6}
                            style={{width: '100%', padding: '10px', border: '1px solid #ced4da', borderRadius: '4px', resize: 'vertical'}}
                            value={updatedMemoData}
                            onChange={(e) => setUpdatedMemoData(e.target.value)}
                        ></textarea>
                    </div>
                    <div className='flex flex-row justify-end'>
                        <div className='m-[10px]'>
                            <Button
                                label={'キャンセル'}
                                onClick={onClose}
                            />
                        </div>
                        <div className='m-[10px]'>
                            <Button
                                label={'保存'}
                                onClick={() => onConfirm(updatedMemoData)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MemoModal;